import PermissionsAccordion from 'admin/pages/UserIndividual/Components/PermissionsAccordion';
import { AdminTextField, Errortext } from 'app/components/AdminTextField';
import { FormSkeletonLoader } from 'app/components/FormSkeletonLoader';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { Module } from 'services/openapi';
import styled from 'styled-components';
type Props = {
  rolePermissionsList?: Module[];
  setRolePermissionsList: React.Dispatch<React.SetStateAction<Module[] | null>>;
  loading?: boolean;
  setRoleTitle?: React.Dispatch<React.SetStateAction<string>>;
  setError?: React.Dispatch<React.SetStateAction<string>>;
  roleTitle?: string;
  error?: string;
};
const AddNewRole = ({
  rolePermissionsList,
  setRolePermissionsList,
  setRoleTitle,
  roleTitle,
  loading,
  setError,
  error,
}: Props) => {
  const handleRoleTitle = e => {
    const value = e.target.value;

    // Check length constraint
    if (value.length > 100) return;

    // Clear error when field is empty
    if (value === '') {
      setError?.('');
      setRoleTitle?.(value);
      return;
    }

    // Check if input contains only allowed characters (letters, numbers, and hyphens)
    const validCharactersRegex = /^[a-zA-Z0-9\s-]+$/;
    const isValid = validCharactersRegex.test(value);

    if (!isValid) {
      setError?.('Only alphabets, numbers and hyphens (-) are allowed');
    } else if (value.trim() === '') {
      // Check if string is only whitespace
      setError?.('Role title cannot be empty or blank.');
    } else {
      setError?.('');
    }

    setRoleTitle?.(value);
  };
  return (
    <AddRoleWrapper>
      {loading ? (
        <FormSkeletonLoader />
      ) : (
        <>
          <AdminTextField
            label="Role Title"
            placeholder=""
            value={roleTitle}
            onChange={handleRoleTitle}
            name="title"
            className="add-field-style"
            validations="required"
            hideStar={false}
          />
          {error && <Errortext>{error}</Errortext>}
        </>
      )}

      {loading ? (
        <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
      ) : (
        <PermissionsAccordion
          rolePermissionsList={rolePermissionsList ?? []}
          setRolePermissionsList={setRolePermissionsList}
        />
      )}
    </AddRoleWrapper>
  );
};

export default AddNewRole;
const AddRoleWrapper = styled.div`
  .add-field-style {
    margin-bottom: 0 !important;
  }
  .add-field-style {
    width: 40%;
    max-width: 360px;
    min-width: 300px;
    margin-bottom: 50px;
  }
`;
